'use client'

import * as React from 'react'
import * as RadioGroupPrimitive from '@radix-ui/react-radio-group'
import {Circle} from 'lucide-react'

import {cn} from '@/lib/utils'

type RadioGroupProps = {
    className?: string
    'data-testid'?: string | undefined
}

const RadioGroup = React.forwardRef<
    React.ElementRef<typeof RadioGroupPrimitive.Root>,
    React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Root> & RadioGroupProps
>(({className, 'data-testid': dataTestId, ...props}, ref) => {
    return (
        <RadioGroupPrimitive.Root
            className={cn('grid gap-2', className)}
            data-testid={dataTestId || 'RadioGroup'}
            {...props}
            ref={ref}
        />
    )
})
RadioGroup.displayName = RadioGroupPrimitive.Root.displayName

type RadioGroupItem = {
    className?: string
    'data-testid'?: string | undefined
}

const RadioGroupItem = React.forwardRef<
    React.ElementRef<typeof RadioGroupPrimitive.Item>,
    React.ComponentPropsWithoutRef<typeof RadioGroupPrimitive.Item> & RadioGroupItem
>(({className, 'data-testid': dataTestId, ...props}, ref) => {
    return (
        <RadioGroupPrimitive.Item
            ref={ref}
            className={cn(
                'aspect-square rounded-full border-primary ring-offset-background focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 w-7 h-7 border-[1.5px] border-radio-border [&[data-state=checked]]:border-accent [&[data-state=checked]_svg]:w-[1.125rem] [&[data-state=checked]_svg]:h-[1.125rem] text-accent',
                className
            )}
            data-testid={dataTestId || 'RadioGroupItem'}
            {...props}
        >
            <RadioGroupPrimitive.Indicator className="flex items-center justify-center">
                <Circle
                    className="h-2.5 w-2.5 fill-current text-current"
                    data-testid={dataTestId || 'radio-group-Circle'}
                />
            </RadioGroupPrimitive.Indicator>
        </RadioGroupPrimitive.Item>
    )
})
RadioGroupItem.displayName = RadioGroupPrimitive.Item.displayName

export {RadioGroup, RadioGroupItem}
